import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Entity, Guard, Result, UniqueEntityID } from '@digibricks/core';
export var LlmModel = /*#__PURE__*/function (_Entity) {
  _inherits(LlmModel, _Entity);

  var _super = _createSuper(LlmModel);

  function LlmModel() {
    _classCallCheck(this, LlmModel);

    return _super.apply(this, arguments);
  }

  _createClass(LlmModel, [{
    key: "name",
    get: function get() {
      return this.props.name;
    }
  }, {
    key: "displayName",
    get: function get() {
      return this.props.displayName;
    }
  }, {
    key: "description",
    get: function get() {
      return this.props.description;
    }
  }, {
    key: "isDefault",
    get: function get() {
      return this.props.isDefault;
    }
  }, {
    key: "providerId",
    get: function get() {
      return this.props.providerId;
    }
  }, {
    key: "applicableUserPlans",
    get: function get() {
      return this.props.applicableUserPlans;
    }
  }, {
    key: "allowedFileExtensions",
    get: function get() {
      return this.props.allowedFileExtensions;
    }
  }, {
    key: "fileSizeLimit",
    get: function get() {
      return this.props.fileSizeLimit;
    }
  }, {
    key: "totalSizeLimit",
    get: function get() {
      return this.props.totalSizeLimit;
    }
  }], [{
    key: "create",
    value: function create(props) {
      var guardCollections = [{
        argument: props.name,
        argumentName: 'Name'
      }, {
        argument: props.displayName,
        argumentName: 'DisplayName'
      }, {
        argument: props.description,
        argumentName: 'Description'
      }, {
        argument: props.type,
        argumentName: 'Type'
      }, {
        argument: props.providerId,
        argumentName: 'ProviderId'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollections);

      if (!guardResult.succeeded) {
        var _guardResult$message;

        return Result.fail((_guardResult$message = guardResult.message) !== null && _guardResult$message !== void 0 ? _guardResult$message : 'Invalid llm model props');
      }

      return Result.ok(new LlmModel(props, new UniqueEntityID(props.name)));
    }
  }]);

  return LlmModel;
}(Entity);